import React, { Component } from 'react';

// icons
import 'font-awesome/css/font-awesome.min.css';

import {PROXIED_MEDIABASE} from './constants'

import './screenView.css'

export default class CustomViewer extends Component { 

  constructor(props) {
    super(props); 
    this.state = {
    preview: false,
  };

  this.shadowref = React.createRef();
  }


  componentWillReceiveProps(props) {
    if (props.screenid !== this.props.screenid) {
      // this.setState({loaded: false, preview: false});
      console.log('component received new props');
    }
  }


  componentDidMount() {
    console.log(this.state.width + 'vss ' + this.shadowref.current.clientWidth);   
    var host = document.querySelector('#my-shadow-host');
    var root = host.attachShadow({mode: 'open'});
    if (host.shadowRoot === root) {
        // Then it is hosting a Shadow DOM element
        const myDivElement = document.createElement('div');
        myDivElement.setAttribute('id', 'my-shadow-div');
        myDivElement.style.backgroundColor= this.props.screenbg;
        myDivElement.innerHTML = this.props.screenpdf;
        myDivElement.style.padding = '13px';
        host.shadowRoot.appendChild(myDivElement);

        let containerWidth = this.shadowref.current.clientWidth;
        console.log("ELement width: " + containerWidth);
        const images = myDivElement.querySelectorAll('img[src^="data:image"]');
        images.forEach(image => {
          if(image.width > (containerWidth)){
            // checks to ensure its only applied to large images ~ Larger than the lesson container
            const aspectRatio = image.width/image.height;
            image.width =`${containerWidth - 30}`;
            image.height= `${image.height/aspectRatio}`;
            image.style.border="#18ee97 dotted 2px";
          }          
        });
    }

    else {
          // Select your shadow host
          const shadowHost = document.getElementById('my-shadow-host');
          // Create the shadow root
          const shadowRoot = shadowHost.attachShadow({ mode: 'open' });

          const myDivElement = document.createElement('div');
          myDivElement.setAttribute('id', 'my-shadow-div');
          myDivElement.style.backgroundColor= this.props.screenbg;
          myDivElement.style.padding = '13px';
          myDivElement.innerHTML = this.props.screenpdf;

      
          // Append div to shadow DOM
          shadowRoot.appendChild(myDivElement);
          this.myDivElement = myDivElement;  
        //     const images = myDivElement.querySelectorAll('img[src^="data:image"]');
        //  images.forEach(image => {
        //    image.style.maxWidth = "500px !important";
        //    image.style.width ="500px !important"
        //    image.style.height = "auto !important"
        //    image.style.border="2px solid green"
        //  });
    } 
  }
  render() {
    console.info("SV Rendered");
    return (
      <div style={{width: "100%"}} id='my-shadow-host' ref={this.shadowref}/>      
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/screenViewerHtml.js